import { useEffect, useState } from 'react';
import { OfflineBanner } from '@/components/OfflineBanner/OfflineBanner';

/**
 * Listens to navigator.onLine and online/offline events. When offline, shows a
 * slim banner at the top (header area) and keeps the app visible.
 */
export const OfflineDetector = ({ children }: { children: React.ReactNode }) => {
    const [isOnline, setIsOnline] = useState(
        // Node defines `navigator` but not `navigator.onLine`, so test the property, not the
        // object: a server render must never claim the visitor is offline.
        typeof navigator !== 'undefined' && typeof navigator.onLine === 'boolean' ? navigator.onLine : true,
    );

    useEffect(() => {
        const handleOnline = () => setIsOnline(true);
        const handleOffline = () => setIsOnline(false);

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    return (
        <>
            {!isOnline && (
                <div className="fixed top-0 left-0 right-0 z-[9999]">
                    <OfflineBanner />
                </div>
            )}
            <div className={!isOnline ? 'pt-12' : ''}>{children}</div>
        </>
    );
};
